// @flow
import React from 'react';
import type { Element } from 'react';

import { StyledCover } from './styles';

import type { Props } from '../../types';

const PrimaryButton = (props: Props): Element<any> => {
  const {
    href,
    label,
    onClick,
    className,
    disabled,
    inverted,
    icon = <React.Fragment />
  }: Props = props;

  return (
    <StyledCover
      href={href}
      onClick={onClick}
      className={className}
      disabled={disabled}
      inverted={inverted}
    >
      {icon}
      {label}
    </StyledCover>
  );
};

export default PrimaryButton;
